import { render, staticRenderFns } from "./factoryDetail.vue?vue&type=template&id=835bea36"
import script from "./factoryDetail.vue?vue&type=script&lang=js"
export * from "./factoryDetail.vue?vue&type=script&lang=js"
import style0 from "../assets/css/factoryDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports